<!--
* @summaryription 最新动态
-->
<template>
  <div class="zxyhy_container" v-if="lists.length > 0">
    <div class="zxyhy_wrapper">
      <aside class="zxyhy-aside">
        <h1 class="title">News</h1>
        <span class="more_button" @click="moreNews">Learn More ></span>
      </aside>
      <article class="news-list">
        <div
          v-for="(item, index) in lists"
          :key="index"
          class="news-item"
          @click="goDetail(item)"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200 * index,
          }"
        >
          <div class="news-item-header">
            <span class="date">{{ item.publishDate }}</span>
            <span class="news-title">{{ item.title }}</span>
          </div>
          <img :src="item.picUrl" alt="News Image" class="news-image" />
          <p class="news-summaryription">{{ item.summary }}</p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { clientHomeLatestInfoApi } from "@/api/api";
import news1 from "@/views/web/home/imgs/news1.png";
import news2 from "@/views/web/home/imgs/news2.png";
import news3 from "@/views/web/home/imgs/news3.png";

import { infoTopThreeApi } from "@/api/website";
export default {
  name: "zxyhd",
  components: {},
  data() {
    return {
      lists: [], // Initialize with empty array, will be populated by API
    };
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      // Assuming value is a string like "2024-11-19 00:00:00"
      // Extract only the date part
      return value.split(" ")[0];
    },
  },
  computed: {},
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    getInfo() {
      infoTopThreeApi().then((res) => {
        if (res.code === 200 && res.success) {
          console.log("infoTopThreeApi", res);
          if (res.data.length > 0) {
            this.lists = res.data.map((item) => {
              return {
                id: item.id,
                picUrl:
                  item.coverUrlIdList.length > 0
                    ? item.coverUrlIdList[0].path
                    : "",
                linkUrl: "",
                title: item.title,
                publishDate: this.$uniFun.formatDateSimple(
                  item.effectiveTime.split(" ")[0]
                ),
                summary: item.subtitle,
              };
            });
          } else {
            this.lists = [
              // {
              //   id: 1,
              //   title:
              //     "Delauney's Traffic Simulation Software Empowers Singapore's Smart Innovation",
              //   picUrl: news1,
              //   linkUrl: "https://www.baidu.com",
              //   publishDate: "April 8 - 2025",
              //   summary:
              //     "Delauney's independently developed AIRoad-VRRoad integrated design and simulation software was invited to join the laboratory, collaborating with industry organizations, academic institutions, and enterprises to jointly empower road innovation in Singapore.",
              // },
              // {
              //   id: 2,
              //   title:
              //     "Delauney Visits Hanoi, Vietnam for Exchange and Cooperation",
              //   picUrl: news2,
              //   linkUrl: "https://www.baidu.com",
              //   publishDate: "March 23 - 2025",
              //   summary:
              //     "From March 18 to 22, 2025, Delauney General Manager Mr. Xiao Bin and International Business Manager Mr. Zhang Yipin visited Hanoi, Vietnam, to participate in a technical exchange event on digital infrastructure design and intelligent construction.",
              // },
              // {
              //   id: 3,
              //   title:
              //     "Delauney’s Digital Intelligence Products Go Global SITCE 2024 International Intelligent …",
              //   picUrl: news3,
              //   linkUrl: "https://www.baidu.com",
              //   publishDate: "November 9 - 2024",
              //   summary:
              //     "This initiative aimed to explore international market opportunities for industrial startups, marking the beginning of Delauney's digital software and intelligent hardware products venturing into the global market.",
              // },
            ];
          }
        }
      });
    },
    goDetail(item) {
      this.$uniFun.openInCurrentTab(`/pc_index/newsDetail?&id=${item.id}`);
    },
    moreNews() {
      this.$uniFun.openInCurrentTab(`/pc_index/news`);
    },
  },
};
</script>

<style scoped lang="scss">
// 路径可能需要根据您的项目结构调整
@import "@/assets/styles/common.scss";
.zxyhy_container {
  padding: 80px 0px;
  background: #fff;
  .zxyhy_wrapper {
    display: flex;
    width: 100%;
    width: 1200px;
    margin: 0px auto;
  }
  .zxyhy-aside {
    width: 136px;
    min-height: 330px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin-right: 90px;

    .title {
      font-size: 32px;
      font-weight: bold;
      color: #333; // Dark grey color for title
    }

    .more_button {
      display: inline-block;
      width: 136px;
      height: 32px;
      line-height: 32px;
      background: #2f69f2;
      color: white;
      border-radius: 20px;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      transition: background-color 0.3s ease;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .news-list {
    flex: 1;
    display: flex;
    justify-content: space-between; // Distributes space between items
    gap: 20px; // Space between news items
  }

  .news-item {
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease-in-out;

    padding: 0 15px;
    width: calc(
      33.333% - 14px
    ); // For three items with gap (20px * 2 / 3 = ~13.33, adjust for exactness)
    background-color: #fff; // White background for each item
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      .news-image {
        transform: scale(1.05); // Slightly enlarge image on hover
      }
    }

    .news-item-header {
      margin-bottom: 12px;
      .date {
        font-size: 12px;
        color: #999; // Lighter grey for the date
        display: block; // Makes date take its own line or adjust as needed
        margin-bottom: 12px;
      }

      .news-title {
        @extend .text-truncate-multiline; // 应用公共样式
        // 如果需要覆盖默认的行数，可以这样设置：
        // --line-clamp: 3;
        font-size: 14px;
        color: #333;
        line-height: 1.4;
        min-height: calc(1.4em * 2);
      }
    }

    .news-image {
      width: 100%;
      height: 166px; // Adjust height as needed
      object-fit: cover; // Ensures the image covers the area, might crop
      border-radius: 4px;
      margin-bottom: 10px;
      transition: all 0.3s ease;
    }

    .news-summaryription {
      font-size: 12px;
      color: #999; // Medium grey for summaryription
      line-height: 1.6;
      @extend .text-truncate-multiline; // 应用公共样式
      // 如果需要覆盖默认的行数，可以这样设置：
      --line-clamp: 4;
      flex-grow: 1; // Allows summaryription to take available space
    }
  }

  // Responsive adjustments if needed
  @media (max-width: 992px) {
    .news-list {
      flex-direction: column;
      gap: 15px;
    }
    .news-item {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .zxyhy-aside {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    .title {
      font-size: 20px;
    }
    .more_button {
      align-self: flex-start; // Or center, depending on desired mobile layout
    }
  }
}
</style>
